import { render, staticRenderFns } from "./BasePagination.vue?vue&type=template&id=3c017f33&"
import script from "./BasePagination.vue?vue&type=script&lang=ts&"
export * from "./BasePagination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports